export class UserOrderGroup {
    Sale_Order_Id: number
    Customer_Delivery_Date: Date
    Slot_Name: string
    Slot_Start_Time: string
    Order_Amount: number
    Orders: any[] = []
}